var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { class: _vm.$style.container, on: { click: _vm.handleClicked } },
        [
          _vm.showImage
            ? _c("div", { class: _vm.$style["image-container"] }, [
                _c("img", { attrs: { src: _vm.imageSrc, alt: _vm.altText } })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.$style["info-container"] }, [
            _c("div", { class: _vm.$style.title }, [
              _c("span", [_vm._v(_vm._s(_vm.title))])
            ]),
            _vm._v(" "),
            _c("div", { class: _vm.$style.description }, [
              _vm._v(_vm._s(_vm.description))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style["icon-container"] },
            [
              _c("NsIcon", {
                class: _vm.$style["ns-icon"],
                attrs: { "icon-name": "icon-chevron-right", size: "icon-lg" }
              })
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }